import { Trans, useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { CrownIcon } from "lucide-react";

import { SidebarMenuButton, SidebarMenuItem } from "@/shared/ui/sidebar";

import { useProPreview } from "../../lib/useProPreview";

// Пункт «Pro» бокового меню (design/prototype/Sidebar.dc.html, `pro`) — ведёт на «Тарифы».
// Пока оплата не запущена, виден только со ссылки с `?pro=1`.
export const ProNavItem = () => {
  const { t } = useLingui();
  if (!useProPreview()) {
    return null;
  }
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={t`Pro`}>
        <Link to="/pricing">
          <CrownIcon aria-hidden="true" />
          <span>
            <Trans>Pro</Trans>
          </span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
